@if (items.length === 0) {
  <div class="text-subdued px-8 py-2 text-sm">No Calendars found</div>
}

<ng-container
  *nestedFor="
    let calendar of items;
    let index = index;
    let depth = depth;
    let expandable = expandable;
    let itemExpanded = expanded;
    stateKey: treeStateKey
  "
>
  @let checked = selectedItemsIds | includesBy: calendar.id;

  <app-sidebar-item
    class="rounded [&:not(.drag-over)]:hover:bg-hover"
    [title]="calendar.title"
    [actions]="actionsFor(calendar)"
    [depth]="depth"
    [badge]="
      calendar.flagged || calendar.pinned || calendar.snoozed || calendar.followed
        ? {
            template: badgeTemplate,
            context: {
              flagged: calendar.flagged,
              pinned: calendar.pinned,
              snoozed: calendar.snoozed,
              followed: calendar.followed,
            },
          }
        : undefined
    "
    [expandable]="expandable"
    [expanded]="itemExpanded.value"
    [active]="false"
    [iconColor]="calendar.color"
    [withCheckbox]="true"
    [checked]="checked"
    (checkedChange)="onCalendarChecked(calendar, $event)"
    (onExpand)="itemExpanded.next($event)"
    (click)="noteRowClick($event)"
    (appClick)="toggleOnClick(calendar, checked)"
    (appDblClick)="handleDblClick(calendar)"
    [appCalendarContextMenu]="calendar"
    (appCalendarContextMenuOpenCalendar)="openItem(calendar)"
    appDroppable
    appDroppableHoverClass="drag-over"
    [appDroppablePredicate]="dndPredicate(calendar)"
    (appDroppableDrop)="dndDrop($event, calendar)"
    appDraggable
    [appDraggableData]="items | selectedItemsDragData: selectedItemsIds : calendar"
    [appDraggablePlaceholder]="placeholder"
    [appDraggablePlaceholderContext]="{ item: calendar }"
  >
    <button
      type="button"
      class="hidden group-hover:inline-flex group-focus-within:inline-flex border-0 bg-transparent p-0 text-icon-light"
      aria-haspopup="menu"
      [attr.aria-label]="'Options for ' + calendar.title"
      [appCalendarContextMenu]="calendar"
      appCalendarContextMenuMode="popover"
    >
      <app-icon name="sapphire-ellipsis" />
    </button>
  </app-sidebar-item>
</ng-container>

<ng-template #badgeTemplate let-flagged="flagged" let-pinned="pinned" let-snoozed="snoozed" let-followed="followed">
  <div class="badge-template h-full flex flex-col justify-center items-center">
    @if (pinned) {
      <app-icon class="text-primary" name="sapphire-pin-filled" size="xs" />
    }

    @if (flagged) {
      <app-icon class="text-orange-500" name="sapphire-flagged-filled" size="xs" />
    }

    @if (snoozed) {
      <app-icon class="text-orange-500" name="sapphire-snooze" size="xs" />
    }

    @if (followed) {
      <app-icon class="text-primary" name="sapphire-follow-up" size="xs" />
    }
  </div>
</ng-template>
